import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import OrderSchedulingModal from "./OrderSchedulingModal";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import {
  formatDate,
  /*  formatDateTime, */ formatDateWithAMPM,
} from "../../../../common/Validations";

//Serivce
// import LoadingAdviceModal from "./LoadingAdviceModal";
import CreditPolicyRequestFormModal from "../CreditPolicy/CreditPolicyRequestFormModal";
import InvoiceConfirmationModal from "./InvoiceConfirmationModal";
// import LoadingAdviceOrderHistoryModal from "./LoadingAdviceOrderHistoryModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { addcustomerID } from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";
import EwayBillConfirmationModal from "./EwayBillConfirmationModal";
import PrintLoadingAdvice from "./PrintLoadingAdvice";
import { useReactToPrint } from "react-to-print";
import SendEmailModalV2 from "../Common/SendEmailModalV2";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
import "../Style/customer_v2.scss";

const LoadingAdviceList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Loading Advice");

  //print
  const contentRef = useRef(null);

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  let orderSchedulingData = useSelector(
    (state) => state?.customerV1?.order_scheduling,
  ); // User Details from Store
  let orderSchedulingTable = useSelector(
    (state) => state?.customerV1?.order_scheduling.pagination,
  ); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [data, setData] = useState();
  const [filteredUserListColInfo, setFilteredUserListColInfo] = useState([]);

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [getItemLevelData, setItemLevelData] = useState([]);

  const [getLoadingAdvice, setLoadingAdvice] = useState(null);

  const [selectedRowData, setSelectedRowData] = useState(null);

  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);

  const [filterShow, setFilterShow] = useState(false);

  const [getFilter, setFilter] = useState({});

  const lineItemCol = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold  text-primary">
            {row?.materialDescription}{" "}
          </p>
          <p className="m-0 p-0  text-success">{row?.materialCode} </p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Load Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row?.orderQtyLoadConfirm}{" "}
          </p>
          <p className="m-0 p-0 text-success">{row?.uOM} </p>
        </div>
      ),
      width: "120px",
    },
    {
      name: "Date/time",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {formatDate(row?.loadingDate)}
          </p>
          <p className="m-0 p-0 ">{row?.loadingTime} </p>
        </div>
      ),
      width: "160px",
    },

    {
      name: "Godown",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.godownAddress} </p>
          {/* <p className="m-0 p-0 ">{row?.materialCode} </p> */}
        </div>
      ),
      sortable: true,
      width: "200px",
    },

    {
      name: "Truck No",
      cell: (row) => (
        <div>
          {/* <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingTruckNoCode} </p> */}
          {!!row?.loadingOtherTruckNo ? (
            <p className="fw-bold">{row?.loadingOtherTruckNo}</p>
          ) : (
            row?.loadingTruckNoDescription && (
              <p className="fw-bold">{row?.loadingTruckNoDescription}</p>
            )
          )}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Driver",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.transporterDriverName} </p>
          <p className="m-0 p-0 ">{row?.transporterDriverContact} </p>
        </div>
      ),
      width: "160px",
    },
    // {
    //   name: "createdAt",
    //   selector: (row) => row.createdAt,
    //   cell: (row) => (
    //     <>
    //       <div>
    //         <p className="m-0 p-0 ">{row.createdAt} </p>
    //       </div>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },
  ];

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemCol);
    setModalTitle("Line Items");
    setItemLevelModalShow(true);
  };

  const orderSchedulingListColInfo = [
    {
      name: "Loading Nr",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.documentNumber)}
        >
          {row.documentNumber || "-"}
        </button>
      ),
      sortable: true,
      width: "120px",
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.orderStatus,
    //   cell: (row) => (
    //     <>
    //       <TableStatusField status={row.orderStatus} />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "100px",
    // },
    // {
    //   name: "Dispatch Date",
    //   selector: (row) => row.dispatchDate,
    //   cell: (row) => (
    //     <>
    //       <span className="fw-bold text-primary">
    //         {formatDate(row.dispatchDate)}
    //       </span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Created Date",
      id: "createdAt",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {/* {formatDateTime(row.createdAt)} */}
            {formatDateWithAMPM(row.updatedAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Company Code",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc,
      cell: (row) => (
        <>
          <span className="fw-bold text-success">{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.sapDocumentNumber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row.customerName} </p>
            <p className="m-0 p-0 ">{row.sapDocumentNumber} </p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },

    // {
    //   name: "Ex-work",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row?.exWork || "--"} </p>
    //     </div>
    //   ),
    //   width: "100px",
    // },
    {
      name: "Order Nr",
      id: "orderSchedulingNr",
      selector: (row) => row.orderSchedulingNr,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row?.orderSchedulingNr || "--"}
          </span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Truck Nr",
      cell: (row) => {
        const item = Array.isArray(row?.items) ? row.items[0] : row?.items;

        if (!item) return "--";

        return (
          <span className="bg-table-status bg-table-new-status">
            {item.loadingOtherTruckNo ? (
              <p className="fw-bold m-0">
                {item.loadingOtherTruckNo.toUpperCase()}
              </p>
            ) : (
              <p className="fw-bold m-0">
                {item.loadingTruckNoDescription || "--"}
              </p>
            )}
          </span>
        );
      },
      sortable: true,
      width: "140px",
    },

    {
      name: "Godown Addr",
      selector: (row) => row.godownAddressDescription,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">
              {row?.items[0]?.godownAddressDescription}{" "}
            </p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Loading Advice",
      cell: (row) => (
        <div className="my-2">
          <button className="btnTable" onClick={() => handlePrintWithData(row)}>
            Print
          </button>
          <button
            className="btnTable mt-2"
            onClick={() => {
              setSelectedRowData(row);
              setShowSupplierInviteModal(true);
            }}
          >
            Send Mail
          </button>
          {/* <div style={{ display: "none" }}>
            <PrintLoadingAdvice ref={contentRef} data={row} />
          </div> */}
        </div>
      ),
      width: "150px",
    },
    // {
    //   name: "Invoice",
    //   cell: (row) => (
    //     <>

    //       { row.invoiceNr ? (
    //         <span className="bg-table-status bg-table-new-status">
    //           {row.invoiceNr}
    //         </span>
    //       ) : (
    //         <button className="btnTable" onClick={() => showEditInvoice(row)}>
    //           Generate
    //         </button>
    //       )}

    //     </>
    //   ),
    //   width: "150px",
    // },
    {
      name: "Invoice",
      id: "invoiceNr",
      cell: (row) => {
        const accOnOff = row?.items?.[0]?.accOnOff;
        return accOnOff ? (
          row.invoiceNr ? (
            <span className="bg-table-status bg-table-new-status">
              {row.invoiceNr}
            </span>
          ) : (
            <button className="btnTable" onClick={() => showEditInvoice(row)}>
              Generate
            </button>
          )
        ) : null; // or return a placeholder if needed
      },
      width: "150px",
    },
    //  {
    //   name: "A/C",
    //   selector: (row) => row.accOnOff,
    //   sortable: true,
    //   width: "120px",
    //   cell: (row) => (
    //     <div className="form-check form-switch">
    //       <input
    //         className="form-check-input custom-switch"
    //         type="checkbox"
    //         role="switch"
    //         id={`switch-${row.local_id}`}
    //         // checked={true}
    //         checked={row?.items?.[0]?.accOnOff}
    //         // onChange={(event) => handleCheckboxChange(row.local_id, event)}
    //         disabled={true}
    //       />
    //     </div>
    //   ),
    // },
    {
      name: "A/C",
      selector: (row) => row.accOnOff,
      sortable: true,
      width: "120px",
      cell: (row) => {
        const isOn = row?.items?.[0]?.accOnOff;

        return (
          <div className="flex justify-center">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={isOn}
                disabled={true}
              />

              {/* Switch background */}
              <div
                className={`w-11 h-6 rounded-full transition-colors duration-300
              ${isOn ? "bg-green-500" : "bg-red-500"}
            `}
              ></div>

              {/* Circle */}
              <div
                className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300
              ${isOn ? "translate-x-5" : "translate-x-0"}
            `}
              ></div>
            </label>
          </div>
        );
      },
    },

    /* {
      name: "E-Way Bill Nr",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.e_WayBillNo || "--"}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    }, */
    // {
    //   name: "E-way Bill",
    //   cell: (row) => (
    //     <>
    //       {row.e_WayBillNo ? (
    //         <span className="bg-table-status bg-table-new-status">
    //           {row.e_WayBillNo}
    //         </span>
    //       ) : (
    //         <button
    //           className="btnTable"
    //           disabled={row.ewayBill === "Yes" ? false : true}
    //           onClick={() => showEwayBill(row)}
    //         >
    //           Create
    //         </button>
    //       )}
    //     </>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "Credit Policy",
    //   cell: (row) => (
    //     <>
    //       <button
    //         className="btnTable"
    //         onClick={() => showCreditPolicyRequestForm(row)}
    //       >
    //         Request
    //       </button>
    //     </>
    //   ),
    //   width: "150px",
    // },

    {
      name: "Created By",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row.createdByName} </p>
            <p className="m-0 p-0 ">{row.createdBy} </p>
          </div>
        </>
      ),
      selector: (row) => row.createdByName || "--",
      sortable: true,
      width: "140px",
    },
    // {
    //   name: "Created By",
    //   selector: (row) => row.createdBy,
    //   cell: (row) => (
    //     <>
    //       <div>
    //         <p className="m-0 p-0 ">{row.createdByName} </p>
    //       </div>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },

    //required
    // {
    //   name: "Rescheduling",
    //   cell: (row) => (
    //     <>
    //       <button
    //         className="btnTable"
    //         // onClick={() => changeOrder(row)}
    //       >
    //         Edit{row.publish}
    //       </button>
    //     </>
    //   ),
    //   width: "150px",
    // },
  ];
  const [getDocumentNumber, setDocumentNumber] = useState("");

  // useReactToPrint declared at top level
  useEffect(() => {
    if (getDocumentNumber) {
      handlePrint();
    }
    // eslint-disable-next-line
  }, [getDocumentNumber]);

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `loadingAdvice_${getDocumentNumber || ""}`,
    //     onAfterPrint: () => {
    //   setDocumentNumber("");
    // },
  });

  const handlePrintWithData = (row) => {
    setLoadingAdvice(row);
    setDocumentNumber(row?.documentNumber);
    // Wait for state updates before printing
    // setTimeout(() => {
    //   handlePrint();
    // }, 500);
  };

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;
    const restrictedColumns = {
      "SALES-MANAGER": ["Process"],
      "SALES-OFFICER": ["Process"],
      "SALES-COORDINATOR": [],
      "GENERAL-MNGR": ["Process"],
      "SALES-DIRECTOR": ["Process"],
      "DISPATCH-SNR-OFFICER": ["Process"],
      "DISPATCH-OFFICER": ["Process"],
    };

    const filteredCol = orderSchedulingListColInfo.filter(
      (col) => !restrictedColumns[userRole]?.includes(col.name),
    );

    setFilteredUserListColInfo(filteredCol);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const [getOrderSheduling, setOrderSheduling] = useState(false);

  const [getCreditPolicyFormModal, setCreditPolicyFormModal] = useState(false);

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getCreditPolicyFormData, setCreditPolicyFormData] = useState();

  const hideOrderScheduling = () => {
    setOrderSheduling(false);

    let obj = {
      queryName: "getLoadingAdviceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getOrderSchedulingList(obj));
  };

  const loadInitialSuuplierData = async () => {
    setData(orderSchedulingData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "getLoadingAdviceList",
        module: "CUSTOMER",
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "getLoadingAdviceList",
        module: "CUSTOMER",
        page: page,
        per_page: getNewPerPage,
      };
    }
    dispatch(getOrderSchedulingList(obj));
    setData(orderSchedulingData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "getLoadingAdviceList",
        module: "CUSTOMER",
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "getLoadingAdviceList",
        module: "CUSTOMER",
        page: page,
        per_page: newPerPage,
      };
    }

    setNewPerPage(newPerPage);
    dispatch(getOrderSchedulingList(obj));
    setData(orderSchedulingData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getLoadingAdviceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getOrderSchedulingList(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSchedulingData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getLoadingAdviceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getOrderSchedulingList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //CreditPolicyRequestFormModal
  // eslint-disable-next-line no-unused-vars
  const showCreditPolicyRequestForm = (items) => {
    setCreditPolicyFormData(items);
    setCreditPolicyFormModal(true);
  };

  const hideCreditPolicyRequestForm = () => {
    setCreditPolicyFormModal(false);
  };

  //invoice
  const [getModalEditInvoice, setModalEditInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const showEditInvoice = (rowData) => {
    setModalEditInvoice(true);
    setInvoiceData(rowData);
  };
  const hideInvoiceModal = () => {
    setModalEditInvoice(false);
    setEwayBillData(null);
  };

  //EwayBill
  const [getModalEwayBill, setModalEwayBill] = useState(false);
  const [ewayBillData, setEwayBillData] = useState(null);

  const hideEwayBillModal = () => {
    setModalEwayBill(false);
    setEwayBillData(null);
  };

  const detailedPage = (customerID) => {
    dispatch(addcustomerID(customerID));
    navigate(CustomerConstants.CUSTOMER_V2_LOADING_ADVICE_DETAIL);
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getLoadingAdviceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getOrderSchedulingList(obj));
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Loading Advice</h2>
                <p className="subText">Loading Advice List</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt || ""}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            <Col xs={12} md={12} lg={12}>
              {filterShow && (
                <CommonFilterCustomerV2
                  getfiltereddata={orderSchedulingListColInfo}
                  cancelAction={() => setFilterShow(!filterShow)}
                  onSubmit={(filters) => {
                    // console.log(">>Received filters from child:", filters);
                    // const filterData=[filters]
                    handleAdvanceSearchFuncApi(filters);
                    // You can now use the filters here
                  }}
                />
              )}
            </Col>

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LA</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Loading Advice</span>
                      <span className="subHeaderTitle">
                        Loading Advice List{" "}
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={filteredUserListColInfo}
                          data={data}
                          progressPending={orderSchedulingData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={orderSchedulingTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div style={{ display: "none" }}>
        <PrintLoadingAdvice ref={contentRef} data={getLoadingAdvice} />
      </div>
      <CreditPolicyRequestFormModal
        show={getCreditPolicyFormModal}
        onHide={() => hideCreditPolicyRequestForm(getCreditPolicyFormModal)}
        data={getCreditPolicyFormData}
        onSuccess={() => handleSearchFuncApi()}
      />
      <OrderSchedulingModal
        show={getOrderSheduling}
        onHide={hideOrderScheduling}
        clear={true}
      />
      <InvoiceConfirmationModal
        show={getModalEditInvoice}
        onHide={() => hideInvoiceModal()}
        invoiceinfo={invoiceData}
        // onsuccessdata={handleSuccessData}
        // viewInvoiceData={viewInvoiceData}
      />
      <EwayBillConfirmationModal
        show={getModalEwayBill}
        onHide={() => hideEwayBillModal()}
        ewaybill={ewayBillData}
        // onsuccessdata={handleSuccessData}
        // viewInvoiceData={viewInvoiceData}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <SendEmailModalV2
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        // onSubmit={inviteSupplier}
        data={selectedRowData}
      />
    </main>
  );
};

export default LoadingAdviceList;
